import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import Swal from "sweetalert2";
import { Circles } from "react-loader-spinner";
import "moment/locale/es";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-fixedcolumns-bs5/css/fixedColumns.bootstrap5.min.css";
import "datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css";

const $ = require("jquery");
$.DataTable = require("datatables.net");
require("datatables.net-bs5");
require("datatables.net-buttons");
require("datatables.net-buttons/js/buttons.colVis.min.js");
require("datatables.net-buttons/js/buttons.html5.min.js");
require("datatables.net-buttons/js/buttons.print.min.js");
require("datatables.net-buttons-bs5");
require("datatables.net-responsive");
require("datatables.net-responsive-bs5");
require("datatables.net-fixedcolumns");
require("datatables.net-fixedcolumns-bs5");

Moment.locale("es");

function CreateRequests() {
  const modules = JSON.parse(localStorage.getItem("modulos")) || [];
  const location = useLocation();

  const tabs = [
    { name: "Crear", to: "/deals/request", module: "deals-request" },
    { name: "Solicitudes", to: "/deals/update", module: "deals-update" },
    { name: "Resumen", to: "/deals/requests", module: "deals-requests" },
    { name: "Ranking", to: "/deals/ranking", module: "deals-ranking" },
  ];

  const [mailData, setMailData] = useState([]);
  const tableRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [enviandoReporte, setEnviandoReporte] = useState(false);

  const [filters, setFilters] = useState({
    asesor: "",
    financiera: "",
    status: "",
    agencia: "",
    nombre: "",
    startDate: "",
    endDate: "",
  });

  const [filterOptions, setFilterOptions] = useState({
    asesor: [],
    financiera: [],
    status: [],
    agencia: [],
    nombre: [],
  });

  const accessToken =
    "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3";

  const apiUrl = "https://api.checkmark.mx/solicitudes/consultar";

  const apiUrlEnviarReporte =
    "https://api.checkmark.mx/reportes/solicitudes/semanal/enviar";

  const correoAsesor = (localStorage.getItem("userEmail") ?? "")
    .trim()
    .toLowerCase();

  const usuariosPermitidosReporte = [
    "jaime.reyesr22@gmail.com",
    "alombera@gocar.auto",
    "roberto.martinez@gocar.auto",
    "wtorres@gocar.auto",
    "rmaldonado@gocar.auto",
  ];

  const puedeEnviarReporte = usuariosPermitidosReporte.includes(correoAsesor);

  const safeJsonParse = (value, fallback = []) => {
    if (value === null || value === undefined || value === "") return fallback;
    if (Array.isArray(value)) return value;
    if (typeof value === "object") return value;

    try {
      let parsed = JSON.parse(value);

      // A veces la API puede regresar JSON doblemente encodeado:
      // "\"[{...}]\"" -> primer parse da string -> segundo parse da array.
      if (typeof parsed === "string") {
        parsed = JSON.parse(parsed);
      }

      return parsed ?? fallback;
    } catch (error) {
      return fallback;
    }
  };

  const normalizeText = (value) => {
    return String(value || "").trim();
  };

  const normalizeTextLower = (value) => {
    return String(value || "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  };

  const getNombreCompleto = (persona) => {
    const nombre = normalizeText(persona?.nombre);
    const apellidoPaterno = normalizeText(persona?.apellido_paterno);

    return [nombre, apellidoPaterno].filter(Boolean).join(" ") || "Sin nombre";
  };

  const getNombreFiltro = (item) => {
    if (typeof item === "string" || typeof item === "number") {
      return normalizeText(item);
    }

    return getNombreCompleto(item);
  };

  const NOMBRE_FILTER_SEPARATOR = "|||";

  const crearValorFiltroNombre = (persona) => {
    const nombre = normalizeText(persona?.nombre);
    const apellidoPaterno = normalizeText(persona?.apellido_paterno);

    return `${nombre}${NOMBRE_FILTER_SEPARATOR}${apellidoPaterno}`;
  };

  const obtenerDatosFiltroNombre = (value) => {
    const valor = normalizeText(value);

    if (!valor) {
      return {
        nombre: "",
        apellido_paterno: "",
      };
    }

    const [nombre = "", apellidoPaterno = ""] = valor.split(
      NOMBRE_FILTER_SEPARATOR,
    );

    return {
      nombre: normalizeText(nombre),
      apellido_paterno: normalizeText(apellidoPaterno),
    };
  };

  const normalizeStatus = (value) => {
    const v = normalizeTextLower(value);

    if (!v || v === "sin status") return "Sin status";
    if (v === "autorizado") return "Autorizado";
    if (v === "rechazado") return "Rechazado";
    if (v === "pendiente de buro") return "Pendiente de Buro";
    if (v === "cotizacion") return "Cotización";
    if (v === "formalizado") return "Formalizado";

    return normalizeText(value) || "Sin status";
  };

  const normalizeSubStatus = (value) => {
    const v = normalizeTextLower(value);

    if (!v || v === "sin substatus") return "Sin substatus";
    if (v === "analisis") return "Analisis";
    if (v === "incompleto") return "Incompleto";
    if (v === "condicionado viable") return "Condicionado Viable";
    if (v === "condicionado no viable") return "Condicionado No Viable";
    if (v === "facturado") return "Facturado";
    if (v === "formalizado") return "Formalizado";
    if (v === "aprobado sin formalizar") return "Aprobado Sin Formalizar";
    if (v === "rechazado") return "Rechazado";

    return normalizeText(value) || "Sin substatus";
  };

  const normalizeTipoAuto = (value) => {
    const v = normalizeTextLower(value);

    if (v.includes("semi")) return "Seminuevo";
    if (v.includes("nuevo")) return "Nuevo";

    return normalizeText(value) || "N/A";
  };

  const getTipoPago = (cliente) => {
    const dependeAuto = normalizeTextLower(
      cliente?.depende_auto ?? cliente?.depente_auto,
    );

    if (dependeAuto === "no") return "Crédito";
    if (dependeAuto === "si") return "Contado";

    return "N/A";
  };

  const isTruthySelected = (value) => {
    if (value === true) return true;
    if (value === 1) return true;

    const normalized = normalizeTextLower(value);

    return ["true", "1", "si", "sí", "selected", "seleccionado"].includes(
      normalized,
    );
  };

  const isValidAccessoryItem = (item) => {
    if (!item) return false;

    if (typeof item === "string") {
      return item.trim() !== "";
    }

    return Boolean(
      item?.title ||
        item?.nombre ||
        item?.name ||
        item?.description ||
        item?.price ||
        item?.precio ||
        item?.price_promo ||
        item?.precio_promo ||
        item?.price_base ||
        item?.precio_base,
    );
  };

  const getAccessoryTitle = (item) => {
    if (typeof item === "string") return normalizeText(item);

    return normalizeText(item?.title || item?.nombre || item?.name);
  };

  const getAccessoryType = (item) => {
    const explicitType = normalizeTextLower(item?.type || item?.tipo);

    if (explicitType.includes("garantia")) return "garantias";
    if (explicitType.includes("garantía")) return "garantias";
    if (explicitType.includes("accesorio")) return "accesorios";

    const title = getAccessoryTitle(item);
    const description =
      typeof item === "object" ? normalizeText(item?.description) : "";

    const text = normalizeTextLower(`${title} ${description}`);

    if (
      text.includes("garantia") ||
      text.includes("garantía") ||
      text.includes("cobertura") ||
      text.includes("proteccion de llantas") ||
      text.includes("protección de llantas") ||
      text.includes("seguro llantas") ||
      text.includes("seguro de llantas") ||
      text.includes("llaves")
    ) {
      return "garantias";
    }

    return "accesorios";
  };

  const getPlanesFinanciamiento = (cliente) => {
    const parsed = safeJsonParse(
      cliente?.planes_financiamiento ??
        cliente?.planesFinanciamiento ??
        cliente?.planes_financiamiento_json,
      [],
    );

    return Array.isArray(parsed) ? parsed : [];
  };

  const getPlanesSeleccionados = (cliente) => {
    const parsed = safeJsonParse(
      cliente?.planes_seleccionados ??
        cliente?.planesSeleccionados ??
        cliente?.planes_seleccionados_json ??
        cliente?.accesorios_garantias ??
        cliente?.accesoriosGarantias ??
        cliente?.adicionales_contado,
      [],
    );

    return Array.isArray(parsed) ? parsed : [];
  };

  const obtenerAccesoriosGarantiasSeleccionados = (cliente) => {
    const planesFinanciamiento = getPlanesFinanciamiento(cliente);

    const selectedPlans = planesFinanciamiento.filter((plan) =>
      isTruthySelected(plan?.isSelected),
    );

    const accessoriesFromSelectedPlans = selectedPlans.flatMap((plan) =>
      Array.isArray(plan?.accessories) ? plan.accessories : [],
    );

    if (accessoriesFromSelectedPlans.length > 0) {
      return accessoriesFromSelectedPlans.filter(isValidAccessoryItem);
    }

    // Fallback para ventas que todavía guardan el arreglo plano en planes_seleccionados.
    return getPlanesSeleccionados(cliente).filter(isValidAccessoryItem);
  };

  const obtenerResumenAccesoriosGarantias = (cliente) => {
    const items = obtenerAccesoriosGarantiasSeleccionados(cliente);

    const resumen = {
      total: 0,
      accesorios: 0,
      garantias: 0,
      nombres: [],
    };

    items.forEach((item) => {
      const title = getAccessoryTitle(item);
      const type = getAccessoryType(item);

      resumen.total += 1;

      if (type === "garantias") {
        resumen.garantias += 1;
      } else {
        resumen.accesorios += 1;
      }

      if (title) {
        resumen.nombres.push(title);
      }
    });

    return resumen;
  };

  const obtenerHistorialFinancieras = (historialCambios) => {
    const parsed = safeJsonParse(historialCambios, []);

    if (!Array.isArray(parsed)) return [];

    return parsed
      .filter((item) => normalizeTextLower(item?.campo) === "financiera")
      .map((item) => ({
        financiera:
          item?.financiera ||
          item?.valor_nuevo ||
          item?.nuevo ||
          item?.nuevo_valor ||
          "N/A",
        fecha: item?.fecha || item?.created_at || item?.fecha_creacion || "",
        descripcion: item?.descripcion || "",
      }));
  };

  const renderHistorialFinancieras = (historialCambios) => {
    const historial = obtenerHistorialFinancieras(historialCambios);

    if (!historial.length) {
      return <span className="black-text">Sin historial</span>;
    }

    return (
      <div style={{ minWidth: "180px" }}>
        {historial.map((item, index) => (
          <div
            key={`${item.financiera}-${item.fecha}-${index}`}
            className="mb-1"
          >
            <span className="fw-semibold">{item.financiera}</span>

            {item.fecha ? (
              <small className="d-block black-text">
                {Moment(item.fecha, "YYYY-MM-DD HH:mm:ss", true).isValid()
                  ? Moment(item.fecha).format("DD/MM/YYYY HH:mm")
                  : item.fecha}
              </small>
            ) : null}
          </div>
        ))}
      </div>
    );
  };

  const getStatusClass = (status) => {
    const normalized = normalizeStatus(status);

    switch (normalized) {
      case "Autorizado":
        return "text-green";
      case "Rechazado":
        return "text-red";
      case "Pendiente de Buro":
        return "text-blue";
      case "Cotización":
        return "text-blue";
      case "Formalizado":
        return "text-green";
      case "Sin status":
        return "black-text";
      default:
        return "black-text";
    }
  };

  const getSubstatusClass = (substatus) => {
    const normalized = normalizeSubStatus(substatus);

    switch (normalized) {
      case "Analisis":
        return "black-text";
      case "Condicionado Viable":
        return "text-purple";
      case "Condicionado No Viable":
        return "text-red";
      case "Incompleto":
        return "text-red";
      case "Facturado":
        return "text-green";
      case "Formalizado":
        return "text-green";
      case "Aprobado Sin Formalizar":
        return "text-olivedrab";
      case "Rechazado":
        return "text-red";
      case "Sin substatus":
        return "black-text";
      default:
        return "black-text";
    }
  };

  const formatFecha = (fecha) => {
    if (!fecha) return "N/A";

    const momentDate = Moment(
      fecha,
      [
        "YYYY-MM-DD",
        "YYYY-MM-DD HH:mm:ss",
        "DD/MM/YYYY",
        "DD/MM/YYYY HH:mm:ss",
        Moment.ISO_8601,
      ],
      true,
    );

    if (momentDate.isValid()) {
      return momentDate.format("DD/MM/YYYY");
    }

    const fallback = Moment(fecha);
    return fallback.isValid() ? fallback.format("DD/MM/YYYY") : "N/A";
  };

  const destroyDataTable = () => {
    if ($.fn.DataTable.isDataTable("#datatableDefault")) {
      $("#datatableDefault").DataTable().destroy();
    }
  };

  const fetchData = async () => {
    setLoading(true);

    try {
      destroyDataTable();

      const agenciasStorage =
        JSON.parse(localStorage.getItem("agencias")) || [];
      const modulos = JSON.parse(localStorage.getItem("modulos")) || [];
      const userId = localStorage.getItem("userId");

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          access_token: accessToken,
          modulos,
          usuario_id: userId,
          agencias: agenciasStorage,
          asesor: filters.asesor,
          financiera: filters.financiera,
          status: filters.status,
          agencia: filters.agencia,
          nombre: obtenerDatosFiltroNombre(filters.nombre).nombre,
          apellido_paterno: obtenerDatosFiltroNombre(filters.nombre)
            .apellido_paterno,
          startDate: filters.startDate,
          endDate: filters.endDate,
        }),
      });

      const data = await response.json();
      console.log("Respuesta de la API:", data);

      if (data.statusCode === 200) {
        if (
          Array.isArray(data.data.resultados) &&
          data.data.resultados.length > 0
        ) {
          const processedData = data.data.resultados.map((cliente) => {
            const resumenAccesoriosGarantias =
              obtenerResumenAccesoriosGarantias(cliente);

            return {
              ...cliente,
              status_normalizado: normalizeStatus(cliente.status),
              sub_status_normalizado: normalizeSubStatus(cliente.sub_status),
              tipo_auto_normalizado: normalizeTipoAuto(cliente.tipo_auto),
              tipo_pago: getTipoPago(cliente),
              nombre_completo: getNombreCompleto(cliente),
              accesorios_count: resumenAccesoriosGarantias.total,
              accesorios_garantias_total: resumenAccesoriosGarantias.total,
              accesorios_total: resumenAccesoriosGarantias.accesorios,
              garantias_total: resumenAccesoriosGarantias.garantias,
              accesorios_garantias_nombres:
                resumenAccesoriosGarantias.nombres.join(", "),
              historial_financieras: obtenerHistorialFinancieras(
                cliente.historial_cambios,
              ),
            };
          });

          setMailData(processedData);
        } else {
          setMailData([]);
        }
      } else if (data.statusCode === 404) {
        setMailData([]);
      } else {
        setMailData([]);

        Swal.fire({
          icon: "warning",
          title: "No se pudo consultar",
          text:
            data.error?.description ||
            data.data?.description ||
            data.message ||
            "No se pudieron obtener las solicitudes.",
        });
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);

      setMailData([]);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al obtener las solicitudes.",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchFilterOptions = async () => {
    try {
      const agenciasStorage =
        JSON.parse(localStorage.getItem("agencias")) || [];
      const modulos = JSON.parse(localStorage.getItem("modulos")) || [];
      const userId = localStorage.getItem("userId");

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          access_token: accessToken,
          modulos,
          usuario_id: userId,
          agencias: agenciasStorage,
        }),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        const opciones = data.data?.opciones || {};

        setFilterOptions({
          asesor: Array.isArray(opciones.asesor) ? opciones.asesor : [],
          financiera: Array.isArray(opciones.financiera)
            ? opciones.financiera
            : [],
          status: Array.isArray(opciones.status) ? opciones.status : [],
          agencia: Array.isArray(opciones.agencia) ? opciones.agencia : [],
          nombre: Array.from(
            new Map(
              (Array.isArray(data.data?.resultados) ? data.data.resultados : [])
                .filter(
                  (cliente) =>
                    normalizeText(cliente?.nombre) ||
                    normalizeText(cliente?.apellido_paterno),
                )
                .map((cliente) => [
                  crearValorFiltroNombre(cliente),
                  {
                    nombre: normalizeText(cliente?.nombre),
                    apellido_paterno: normalizeText(
                      cliente?.apellido_paterno,
                    ),
                  },
                ]),
            ).values(),
          ).sort((a, b) =>
            getNombreCompleto(a).localeCompare(getNombreCompleto(b), "es", {
              sensitivity: "base",
            }),
          ),
        });
      } else {
        setFilterOptions({
          asesor: [],
          financiera: [],
          status: [],
          agencia: [],
          nombre: [],
        });

        console.error(
          "Error al obtener las opciones de filtro:",
          data.message || "Sin mensaje de error.",
        );
      }
    } catch (error) {
      setFilterOptions({
        asesor: [],
        financiera: [],
        status: [],
        agencia: [],
        nombre: [],
      });

      console.error("Error al obtener las opciones de filtro:", error);
    }
  };

  useEffect(() => {
    fetchFilterOptions();
  }, []);

  useEffect(() => {
    fetchData();
  }, [filters]);

  useEffect(() => {
    destroyDataTable();

    if (!loading && mailData.length > 0) {
      setTimeout(() => {
        if ($("#datatableDefault").length) {
          tableRef.current = $("#datatableDefault").DataTable({
            dom: "<'row mb-3'<'col-md-4'l><'col-md-8 text-right'<'d-lg-flex justify-content-end'fB>>>t<'row align-items-center mt-3'<'mr-auto col-md-6 mb-3 mb-md-0'i><'mb-0 col-md-6'p>>",
            lengthMenu: [10, 20, 30, 40, 50],
            responsive: false,
            scrollX: true,
            autoWidth: false,
            order: [],
            buttons: [
              {
                extend: "print",
                className: "btn btn-default btn-sm ms-2 mt-3 mt-md-0",
              },
              {
                extend: "csv",
                className: "btn btn-default btn-sm mt-3 mt-md-0",
              },
            ],
          });
        }
      }, 100);
    }

    return () => {
      destroyDataTable();
    };
  }, [loading, mailData]);

  const handleFilterChange = (name, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleDateApplyEvent = (event, picker) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      startDate: picker.startDate.format("YYYY-MM-DD"),
      endDate: picker.endDate.format("YYYY-MM-DD"),
    }));
  };

  const limpiarFiltros = () => {
    setFilters({
      asesor: "",
      financiera: "",
      status: "",
      agencia: "",
      nombre: "",
      startDate: "",
      endDate: "",
    });
  };

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const cancelButton = document.querySelector(".cancelBtn");
      const applyButton = document.querySelector(".applyBtn");

      if (cancelButton && cancelButton.textContent !== "Cancelar") {
        cancelButton.textContent = "Cancelar";
      }

      if (applyButton && applyButton.textContent !== "Aplicar") {
        applyButton.textContent = "Aplicar";
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  const handleEnviarReporteSemanal = async () => {
    const confirmacion = await Swal.fire({
      icon: "question",
      title: "Enviar reporte semanal",
      text: "Se enviará el reporte de solicitudes de la semana pasada a los correos configurados.",
      showCancelButton: true,
      confirmButtonText: "Sí, enviar",
      cancelButtonText: "Cancelar",
    });

    if (!confirmacion.isConfirmed) return;

    setEnviandoReporte(true);

    try {
      const response = await fetch(apiUrlEnviarReporte, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          access_token: accessToken,
        }),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Reporte enviado",
          html: `
            <p>${
              data.data?.periodo
                ? `Periodo: <strong>${data.data.periodo}</strong>`
                : "El reporte semanal fue enviado correctamente."
            }</p>
            <p>Total solicitudes: <strong>${
              data.data?.total_solicitudes ?? 0
            }</strong></p>
          `,
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "No se pudo enviar",
          text:
            data.error?.description ||
            data.data?.description ||
            data.message ||
            "No se pudo enviar el reporte semanal.",
        });
      }
    } catch (error) {
      console.error("Error al enviar reporte semanal:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al intentar enviar el reporte semanal.",
      });
    } finally {
      setEnviandoReporte(false);
    }
  };

  return (
    <div>
      {loading ? (
        <div className="loader-data">
          <Circles height="80" width="80" color="#4fa94d" />
        </div>
      ) : (
        <div>
          <div className="mailbox">
            <div className="mailbox-toolbar">
              {tabs.map((tab) =>
                modules.includes(tab.module) ? (
                  <div className="mailbox-toolbar-item" key={tab.name}>
                    <Link
                      to={tab.to}
                      className={`mailbox-toolbar-link ${
                        location.pathname === tab.to ? "active" : ""
                      }`}
                    >
                      {tab.name}
                    </Link>
                  </div>
                ) : null,
              )}
            </div>

            <div className="mailbox-body" style={{ display: "block" }}>
              <div className="row">
                <div className="col-12">
                  <div className="mailbox-content">
                    <div className="mailbox-detail">
                      <h1 className="page-header">
                        Gráficas{" "}
                        <small>
                          estadísticas, descripción general y rendimiento
                        </small>
                      </h1>

                      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                        <DateRangePicker
                          startDate={
                            filters.startDate
                              ? Moment(filters.startDate, "YYYY-MM-DD")
                              : Moment()
                          }
                          endDate={
                            filters.endDate
                              ? Moment(filters.endDate, "YYYY-MM-DD")
                              : Moment()
                          }
                          onApply={handleDateApplyEvent}
                        >
                          <a
                            href="#/"
                            className="btn btn-secondary btn-sm d-inline-flex align-items-center"
                          >
                            <span>
                              {filters.startDate && filters.endDate
                                ? `${filters.startDate} - ${filters.endDate}`
                                : "Selecciona un rango"}
                            </span>
                            <i className="fa fa-chevron-down ms-2 fs-8px"></i>
                          </a>
                        </DateRangePicker>

                        {puedeEnviarReporte && (
                          <button
                            type="button"
                            className="btn btn-primary btn-sm d-inline-flex align-items-center"
                            onClick={handleEnviarReporteSemanal}
                            disabled={enviandoReporte}
                          >
                            {enviandoReporte ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Enviando reporte...
                              </>
                            ) : (
                              <>
                                <i className="fa-solid fa-envelope me-2"></i>
                                Enviar reporte semanal
                              </>
                            )}
                          </button>
                        )}
                      </div>

                      <div className="card mb-3">
                        <div className="card-body">
                          <div className="row g-3 align-items-end">
                            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                              <label className="form-label">Asesor</label>
                              <select
                                className="form-select"
                                value={filters.asesor}
                                onChange={(e) =>
                                  handleFilterChange("asesor", e.target.value)
                                }
                              >
                                <option value="">Todos</option>
                                {filterOptions.asesor
                                  .filter(
                                    (item) => item !== null && item !== "",
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={`${item}-${index}`}
                                      value={item}
                                    >
                                      {item}
                                    </option>
                                  ))}
                              </select>
                            </div>

                            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                              <label className="form-label">Financiera</label>
                              <select
                                className="form-select"
                                value={filters.financiera}
                                onChange={(e) =>
                                  handleFilterChange(
                                    "financiera",
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="">Todas</option>
                                {filterOptions.financiera
                                  .filter(
                                    (item) => item !== null && item !== "",
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={`${item}-${index}`}
                                      value={item}
                                    >
                                      {item}
                                    </option>
                                  ))}
                              </select>
                            </div>

                            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                              <label className="form-label">Status</label>
                              <select
                                className="form-select"
                                value={filters.status}
                                onChange={(e) =>
                                  handleFilterChange("status", e.target.value)
                                }
                              >
                                <option value="">Todos</option>
                                {filterOptions.status
                                  .filter(
                                    (item) => item !== null && item !== "",
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={`${item}-${index}`}
                                      value={item}
                                    >
                                      {item}
                                    </option>
                                  ))}
                              </select>
                            </div>

                            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                              <label className="form-label">Agencia</label>
                              <select
                                className="form-select"
                                value={filters.agencia}
                                onChange={(e) =>
                                  handleFilterChange("agencia", e.target.value)
                                }
                              >
                                <option value="">Todas</option>
                                {filterOptions.agencia
                                  .filter(
                                    (item) => item !== null && item !== "",
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={`${item}-${index}`}
                                      value={item}
                                    >
                                      {item}
                                    </option>
                                  ))}
                              </select>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                              <label className="form-label">Nombre</label>
                              <select
                                className="form-select"
                                value={filters.nombre}
                                onChange={(e) =>
                                  handleFilterChange("nombre", e.target.value)
                                }
                              >
                                <option value="">Todos</option>
                                {filterOptions.nombre
                                  .filter((item) => {
                                    if (item === null || item === undefined) {
                                      return false;
                                    }

                                    return getNombreFiltro(item) !== "Sin nombre";
                                  })
                                  .map((item, index) => {
                                    const nombreCompleto = getNombreFiltro(item);

                                    return (
                                      <option
                                        key={`${crearValorFiltroNombre(item)}-${index}`}
                                        value={crearValorFiltroNombre(item)}
                                      >
                                        {nombreCompleto}
                                      </option>
                                    );
                                  })}
                              </select>
                            </div>

                            <div className="col-xl-1 col-lg-2 col-md-3 col-sm-12">
                              <button
                                type="button"
                                className="btn btn-primary w-100"
                                onClick={limpiarFiltros}
                              >
                                Limpiar
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <style>
                        {`
                          .solicitudes-table th,
                          .solicitudes-table td {
                            white-space: nowrap;
                            padding: 10px 18px !important;
                            vertical-align: middle;
                          }

                          .solicitudes-table th {
                            padding-right: 35px !important;
                            position: relative;
                          }

                          table.dataTable thead > tr > th.sorting,
                          table.dataTable thead > tr > th.sorting_asc,
                          table.dataTable thead > tr > th.sorting_desc {
                            padding-right: 35px !important;
                          }

                          table.dataTable thead > tr > th.sorting::before,
                          table.dataTable thead > tr > th.sorting::after,
                          table.dataTable thead > tr > th.sorting_asc::before,
                          table.dataTable thead > tr > th.sorting_asc::after,
                          table.dataTable thead > tr > th.sorting_desc::before,
                          table.dataTable thead > tr > th.sorting_desc::after {
                            right: 12px !important;
                          }

                          .solicitudes-table th:nth-child(1),
                          .solicitudes-table td:nth-child(1) {
                            min-width: 140px;
                          }

                          .solicitudes-table th:nth-child(2),
                          .solicitudes-table td:nth-child(2) {
                            min-width: 190px;
                          }

                          .solicitudes-table th:nth-child(11),
                          .solicitudes-table td:nth-child(11),
                          .solicitudes-table th:nth-child(12),
                          .solicitudes-table td:nth-child(12) {
                            min-width: 160px;
                          }

                          .solicitudes-table th:nth-child(16),
                          .solicitudes-table td:nth-child(16) {
                            min-width: 230px;
                          }
                        `}
                      </style>

                      {mailData.length > 0 ? (
                        <table
                          id="datatableDefault"
                          className="table table-bordered align-middle w-100 solicitudes-table"
                        >
                          <thead>
                            <tr>
                              <th>Folio</th>
                              <th>Nombre Completo</th>
                              <th>Teléfono</th>
                              <th>Asesor</th>
                              <th>Financiera</th>
                              <th>Marca</th>
                              <th>Modelo</th>
                              <th>Tipo Auto</th>
                              <th>Tipo Pago</th>
                              <th>Agencia</th>
                              <th>Fuente</th>
                              <th>Status</th>
                              <th>Sub Status</th>
                              <th>Accesorios / Garantías</th>
                              <th>Venta Babilonia</th>
                              <th>Historial Financieras</th>
                              <th>Fecha de Aplicación</th>
                              <th>Opciones</th>
                            </tr>
                          </thead>

                          <tbody id="datatableDefaultBody">
                            {mailData.map((cliente) => {
                              const status = normalizeStatus(cliente.status);
                              const subStatus = normalizeSubStatus(
                                cliente.sub_status,
                              );
                              const tipoPago = getTipoPago(cliente);

                              return (
                                <tr key={cliente.id}>
                                  <td className="black-text">
                                    {cliente.folio_venta || "N/A"}
                                  </td>

                                  <td className="black-text">
                                    {cliente.nombre_completo || getNombreCompleto(cliente)}
                                  </td>

                                  <td className="black-text">
                                    {cliente.telefono || "N/A"}
                                  </td>

                                  <td className="black-text">
                                    {cliente.asesor || "N/A"}
                                  </td>

                                  <td className="black-text">
                                    {cliente.financiera || "N/A"}
                                  </td>

                                  <td className="black-text">
                                    {cliente.marca_vehiculo || "N/A"}
                                  </td>

                                  <td className="black-text">
                                    {cliente.modelo_vehiculo || "N/A"}
                                  </td>

                                  <td className="black-text">
                                    {cliente.tipo_auto_normalizado || "N/A"}
                                  </td>

                                  <td className="black-text">{tipoPago}</td>

                                  <td className="black-text">
                                    {cliente.agencia || "N/A"}
                                  </td>

                                  <td className="black-text">
                                    {cliente.fuente || "N/A"}
                                  </td>

                                  <td className={getStatusClass(status)}>
                                    {status}
                                  </td>

                                  <td className={getSubstatusClass(subStatus)}>
                                    {tipoPago === "Crédito"
                                      ? subStatus
                                      : "No aplica"}
                                  </td>

                                  <td
                                    className="black-text text-center"
                                    data-order={
                                      cliente.accesorios_garantias_total || 0
                                    }
                                    title={
                                      cliente.accesorios_garantias_nombres ||
                                      ""
                                    }
                                  >
                                    <div className="fw-semibold">
                                      {cliente.accesorios_garantias_total || 0}
                                    </div>
                                    <small className="black-text d-block">
                                      {cliente.accesorios_total || 0} Acc. /{" "}
                                      {cliente.garantias_total || 0} Gar.
                                    </small>
                                  </td>

                                  <td className="black-text">
                                    {cliente.venta_babilonia ||
                                      cliente.venta_babillonia ||
                                      "N/A"}
                                  </td>

                                  <td className="black-text">
                                    {renderHistorialFinancieras(
                                      cliente.historial_cambios,
                                    )}
                                  </td>

                                  <td className="black-text">
                                    {formatFecha(cliente.fecha_creacion)}
                                  </td>

                                  <td>
                                    {Number(cliente.tiene_pdf) === 1 && (
                                      <a
                                        href={`https://api.checkmark.mx/solicitudes/pdf/${cliente.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title="Ver PDF"
                                        className="btn btn-link p-0 me-2"
                                      >
                                        <i className="fas fa-file-pdf text-danger"></i>
                                      </a>
                                    )}

                                    {cliente.telefono ? (
                                      <a
                                        href={`https://wa.me/${
                                          cliente.telefono
                                        }?text=${encodeURIComponent(
                                          `Hola ${cliente.nombre_completo || getNombreCompleto(cliente)}, quería seguir con el proceso de cotización para el vehículo ${cliente.marca_vehiculo} ${cliente.modelo_vehiculo}. ¿Podemos continuar?`,
                                        )}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title="Enviar WhatsApp"
                                        className="btn btn-link p-0"
                                      >
                                        <i className="fab fa-whatsapp text-success"></i>
                                      </a>
                                    ) : (
                                      <span className="text-muted text-black">
                                        Sin número de teléfono.
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      ) : (
                        <div
                          className="mailbox-detail-placeholder"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            textAlign: "center",
                            padding: "35px",
                          }}
                        >
                          No hay datos disponibles para mostrar
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CreateRequests;
